import { BaseProps } from '@/components/types'
import { Backdrop, CircularProgress, Typography } from '@/components'
import useModalStore from '@/store/modal'

function LoadingModal ( props: LoadingModalProps ) {
    const { loadingModalProps, setLoadingModalProps } = useModalStore()
    const { isOpen, message, color, zIndex, isFocusOutClose = false } = loadingModalProps

    const onCustomClick = () => {
        isFocusOutClose && setLoadingModalProps( { ...loadingModalProps, isOpen: false } )
    }

    return (
        <Backdrop
            sx={ { color, zIndex: (theme) => zIndex || theme.zIndex.drawer + 1 } }
            open={ isOpen }
            onClick={ () => { onCustomClick() } }
        >
            <CircularProgress color="inherit"/>
            { message && <Typography sx={ { px: 4 } }>{ message }</Typography> }
        </Backdrop>
    )
}

export default LoadingModal

export interface LoadingModalProps extends BaseProps {}